import styled from "styled-components";

import cursorPointer from "../../assets/cursors/cursor_pointer.png";
import { AbsoluteCentered } from "../Layout";

export const Modal = styled.div`
  display: inline-flex;
  flex-direction: column;
  padding: 24px 32px;
  background-color: #d94556;
  border: 10px solid #ffffff;
  box-shadow: 4px 4px 0 #000000;
  border-radius: 18px;
  max-width: 40vw;
  color: #ffffff;
  word-break: break-word;

  @media screen and (min-width: 1024px) {
    max-width: 30vw;
  }

  @media screen and (min-width: 1200px) {
    max-width: 27vw;
  }

  @media (min-aspect-ratio: 15 / 9) {
    max-width: 22vw;
  }
`;

export const Title = styled.h1`
  text-shadow: 4px 4px 0 #000000;
  text-transform: uppercase;
  margin: 0 0 18px;
  font-weight: 400;

  /* Allow some space for close icon */
  padding-right: 20px;
`;

export const Description = styled.span`
  margin: 0;
  font-size: 1.1em;

  line-height: 1.7em;
`;

export const IconContainer = styled.span`
  position: absolute;
  top: -12px;
  right: -20px;
`;

export const Relative = styled.div`
  position: relative;
  cursor: url(${cursorPointer}) 28 0, pointer;
`;

export const Overlay = styled(AbsoluteCentered)`
  background-color: #0000007d;
`;
